export const SectionHeader = ({ id, label, headline, accent, intro, children }) => (
  <div className="grid grid-cols-12 gap-y-8 gap-x-6 mb-12">
    <div className="col-span-12 lg:col-span-6">
      <div data-testid={`${id}-label`} className="font-mono-label text-[11px] text-[#0F1117] mb-6">/ {label}</div>
      <h2 id={`${id}-title`} data-testid={`${id}-headline`} className="font-display text-3xl sm:text-5xl lg:text-[3.4rem] leading-[1.06] tracking-tight font-extrabold text-[#0F1117] text-balance">
        {headline} {accent && <span className="text-chrome">{accent}</span>}
      </h2>
    </div>
    <div className="col-span-12 lg:col-span-6 lg:col-start-7">
      <p data-testid={`${id}-intro`} className="text-base sm:text-lg text-[#3D4049] leading-relaxed max-w-xl">{intro}</p>
      {children}
    </div>
  </div>
);
